




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class DeliveryAreaFeeModifyFormIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/delivery-area-fee-register?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }

  private receiveMessage(e: MessageEvent) {
    if (e.data.state === 'SUCCESS') {
      window.opener.location.reload();
      window.close()
    }
  }
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
